module.exports = __webpack_public_path__ + "assets/headspace_logo-061a16cfa562fd4265dbf15735ab2e0f.png";